import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type DurationFormatProps } from '@process-advisor/process-miner/api/methods/settings/changeDurationFormat';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const DurationFormat = () => {
    const [DurationFormat, setDurationFormat] = React.useState<DurationFormatProps>({});
    const onChange = _.curry((
        key: keyof DurationFormatProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newDurationFormat = { ...DurationFormat, [key]: e.target.checked };
        setDurationFormat(newDurationFormat);
        apiProvider.changeDurationFormat(newDurationFormat);
        if (apiProvider.getActiveAction() ==='process_miner')  apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setDurationFormat(apiProvider.getDurationFormat());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setDurationFormat(apiProvider.getDurationFormat());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label='days'
                checked={!!DurationFormat.days}
                handleOnChange={onChange('days')} />
            <Checkbox
                label='hours'
                checked={!!DurationFormat.hours}
                handleOnChange={onChange('hours')} />
            <Checkbox
                label='minutes'
                checked={!!DurationFormat.minutes}
                handleOnChange={onChange('minutes')} />
            <Checkbox
                label='seconds'
                checked={!!DurationFormat.seconds}
                handleOnChange={onChange('seconds')} />
        </Wrapper>
    );
};
